import React, { useEffect, useState } from 'react';
import { ToolTip } from '../../common/tool-tip/ToolTip';
import { SaveButton } from '../../common/button/save-button/SaveButton';

import { hasRoles, EDIT_NOTIFICATION_SETTINGS_ROLES } from '../../../util/RoleUtil';

import { createNotificationInterval, viewNotificationInterval } from '../../../services/NotificationIntervalService';

import './CapaNotificationSettings.css';

export const CapaNotificationSettings = ({ context, setSpinnerText, showToaster, toolTipsEnabled, editMode }) => {
  const [capaHours, setCapaHours] = useState('');
  const [capaDays, setCapaDays] = useState('');
  const [queryHours, setQueryHours] = useState('');
  const [queryDays, setQueryDays] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      setSpinnerText('Retrieving Notification Settings');
      const [data, error] = await viewNotificationInterval(context.username);
      if (data) {
        if (data.responseStatus === 'Success' && data.notificationInterval) {
          setQueryHours(data.notificationInterval.queryReviewHours);
          setQueryDays(data.notificationInterval.queryReviewEscalationDays);
          setCapaHours(data.notificationInterval.capaHours);
          setCapaDays(data.notificationInterval.capaEscalationDays);
          showToaster({
            responseStatus: data.responseStatus,
            responseMessage: data.responseMessage,
          });
        } else {
          showToaster({
            responseStatus: data.responseStatus,
            responseMessage: data.responseMessage,
          });
        }
      } else {
        showToaster({
          responseStatus: 'Error',
          responseMessage: error.message,
        });
      }
      setSpinnerText(null);
    };
    fetchData();
  }, [setSpinnerText, context, showToaster]);

  const handleSaveChangesClick = async () => {
    let notificationInterval = {
      notificationInterval: {
        capaEscalationDays: capaDays,
        capaHours: capaHours,
        queryReviewEscalationDays: queryDays,
        queryReviewHours: queryHours,
      },
    };

    setSpinnerText('Saving Notification Settings');
    const [data, error] = await createNotificationInterval(context?.loggedInUser?.userName, notificationInterval);

    if (data) {
      if (data.responseStatus === 'Success') {
        showToaster({
          responseStatus: data.responseStatus,
          responseMessage: data.responseMessage,
        });
      } else {
        showToaster({
          responseStatus: data.responseStatus,
          responseMessage: data.responseMessage,
        });
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
  };

  const handleCancelClick = () => {
    setCapaHours('');
    setCapaDays('');
    setQueryHours('');
    setQueryDays('');
  };

  const fieldsDisabled = !hasRoles(context, EDIT_NOTIFICATION_SETTINGS_ROLES);

  return (
    <div className="notification-settings">
      <div className="notification-settings-content">
        <h3 className="security-questions-header" style={{ marginTop: '40px' }}>
          Query Review Notification Setting
        </h3>
        <div className="notification-settings-input-container">
          <label className="notification-settings-label">
            While Query Review is ongoing, notify stakeholders every
          </label>
          <input
            className="text-input-small"
            type="text"
            value={queryHours}
            onChange={({ target }) => {
              setQueryHours(target.value);
            }}
            disabled={fieldsDisabled}
          />
          <label className="notification-settings-label">hours, escalate after </label>
          <input
            className="text-input-small"
            type="text"
            value={queryDays}
            onChange={({ target }) => {
              setQueryDays(target.value);
            }}
            disabled={fieldsDisabled}
          />
          <label className="notification-settings-label">days. </label>
          {toolTipsEnabled && (
            <div className="form-tooltips">
              <ToolTip
                tooltipExternalReference={'capaNotificationSettings123'}
                context={context}
                setSpinnerText={setSpinnerText}
                showToaster={showToaster}
                fieldName={'Query Review Notification Setting:'}
              />
            </div>
          )}
        </div>

        <h3 className="security-questions-header" style={{ marginTop: '80px' }}>
          CAPA Notification Setting
        </h3>
        <div className="notification-settings-input-container">
          <label className="notification-settings-label">While CAPA Review is ongoing, notify stakeholders every</label>
          <input
            className="text-input-small"
            type="text"
            value={capaHours}
            onChange={({ target }) => {
              setCapaHours(target.value);
            }}
            disabled={fieldsDisabled}
          />
          <label className="notification-settings-label">hours, escalate after </label>
          <input
            className="text-input-small"
            type="text"
            value={capaDays}
            onChange={({ target }) => {
              setCapaDays(target.value);
            }}
            disabled={fieldsDisabled}
          />
          <label className="notification-settings-label">days. </label>
          {toolTipsEnabled && (
            <div className="form-tooltips">
              <ToolTip
                tooltipExternalReference={'capaNotificationSettings123'}
                context={context}
                setSpinnerText={setSpinnerText}
                showToaster={showToaster}
                fieldName={'CAPA Notification Setting:'}
              />
            </div>
          )}
        </div>
      </div>

      {!editMode && (
        <div className="notification-settings-button-container">
          <SaveButton
            color={'#ffffff'}
            textColor={'#077187'}
            border={'1px solid #077187'}
            title={'Cancel'}
            onClick={handleCancelClick}
          />
          <SaveButton
            color={'#077187'}
            title={'Save Changes'}
            onClick={handleSaveChangesClick}
            disabled={fieldsDisabled}
          />
        </div>
      )}
    </div>
  );
};
